import { getImageUrl } from "@hooks/utils/useUpload";
import { Organisation, OrganisationLineItem } from "@interfaces/organisation";

export const decodeOrganisation = async (
  organisation: Organisation
): Promise<OrganisationLineItem> => {
  const presignedUrl =
    organisation.organisation_logo.length > 0
      ? await getImageUrl(organisation.organisation_logo)
      : "";
  return {
    id: organisation.organisation_id,
    organisationName: organisation.organisation_name,
    tradingName: organisation.trading_name,
    abn: organisation.abn,
    representativeName: organisation.representative_name,
    representativeEmail: organisation.representative_email,
    phoneNumber: organisation.phone_number,
    addressLine1: organisation.address_line1,
    addressLine2: organisation.address_line2,
    city: organisation.city,
    postCode: organisation.post_code,
    country: organisation.country,
    state: organisation.state,
    organisationLogoSrc: organisation.organisation_logo,
    organisationLogo: presignedUrl,
    planType: organisation.plan_type,
    created: organisation.created,
    stripeId: organisation.stripe_id,
    users: [],
  };
};

export const encodeOrganisation = (
  organisation: OrganisationLineItem
): Organisation => {
  return {
    organisation_id: organisation.id,
    organisation_name: organisation.organisationName,
    trading_name: organisation.tradingName,
    abn: organisation.abn,
    representative_name: organisation.representativeName,
    representative_email: organisation.representativeEmail,
    phone_number: organisation.phoneNumber,
    address_line1: organisation.addressLine1,
    address_line2: organisation.addressLine2,
    city: organisation.city,
    post_code: organisation.postCode,
    country: organisation.country,
    state: organisation.state,
    organisation_logo: organisation.organisationLogo,
    plan_type: organisation.planType,
    created: organisation.created,
    stripe_id: organisation.stripeId,
    users: organisation.users.map((u) => u.id),
  };
};
